import { Button, Chip, CircularProgress, Grid, Snackbar, TextField, InputLabel } from "@material-ui/core";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import MuiAlert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { updateDisputesNameForUserApi } from "Admin/Sebi/CaseDisplay";
import instance from "api/globalaxios";
import { blockInvalidChar } from "features/TempTiacFormV2/ClaimantPage/questions";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { isSebi } from "Routes/Routes";
import { getRealhost } from "slices/disputeSlice";
import { getCountries } from "slices/profileSlice";
import { getAdditionalEmails, isBacTempEmail, isEmailMandatory, isValidPhone } from "../utils";
import FormError from "../Components/FormError";
import useLocations from "../hooks/useLocations";

const EMAIL_PATTERN = new RegExp(
  /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
);

const sameEmailList = (a, b) =>
  a.length === b.length && a.every((email, i) => email === b[i]);

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: "3rem auto",
    height: "80%",
    width: 600,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
    outline: "none",
    borderRadius: "0.4rem",
    overflowY: "scroll",
  },
  editprofile: {
    fontWeight: "bold",
    fontSize: "24px",
    lineHeight: "23px",
    letterSpacing: "0.6px",
    color: TEXT.secondary,
  },
}));

// partyType is the role the profile plays in this case (claimant, respondent,
// counsel or arbitrator). Additional emails are scoped to dispute + profile +
// party type, so the section only shows when both it and caseId are known.
export default function EditProfileRow({ profileData, dispute_edit, refresh, caseId, profileType, partyType, onSaved }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const haveProfile = profileData.profile ? true : false;
  const isEmailRequired = false;
  // Bar Enrollment No. is only captured for counsels
  const isCounsel = ["lawyer", "lawyer_rv"].includes(
    profileType ||
    (haveProfile ? profileData.profile.profile_type : profileData.profile_type)
  );

  const [allCountries, setallCountries] = useState([]);
  React.useEffect(() => {
    getCountries().then((res) => {
      let result = [...res];
      result.sort(function (a, b) {
        var nameA = a.name.toUpperCase();
        var nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      setallCountries(result);
    });
  }, []);

  const [id, setid] = useState(
    haveProfile ? profileData.profile.id : profileData.id
  );
  const user_id = profileData.user.id;
  const [name, setName] = useState(
    [profileData.user.first_name, profileData.user.last_name]
      .filter(Boolean)
      .join(" ")
  );
  const [phone, setPhone] = useState(
    haveProfile ? profileData.profile.phone_number : profileData.phone_number
  );
  const originalEmail = useRef(profileData.user.email);
  const [errors, setErrors] = useState({});
  const clearError = (key) =>
    setErrors((prev) => (prev[key] ? { ...prev, [key]: "" } : prev));
  const [email, setEmail] = useState(
    isBacTempEmail(profileData.user.email) ? "" : profileData.user.email
  );
  const [address, setAddress] = useState(
    haveProfile ? profileData.profile.address : profileData.address
  );
  const [city, setcity] = useState(
    haveProfile ? profileData.profile.city : profileData.city
  );
  const [region, setregion] = useState(
    haveProfile ? profileData.profile.region || profileData.profile.state : profileData.region || profileData.state
  );
  const [postal_code, setpostal_code] = useState(
    haveProfile ? profileData.profile.postal_code : profileData.postal_code
  );
  const [gst_number, setgst_number] = useState(
    haveProfile ? profileData.profile.gst_number : profileData.gst_number
  );
  const [pan_number, setpan_number] = useState(
    haveProfile ? profileData.profile.pan_number : profileData.pan_number
  );
  const [country, setCountry] = useState(
    dispute_edit ? profileData.profile.country_id : profileData.country
  );
  const [bar_enrollment, setbar_enrollment] = useState(
    (haveProfile
      ? profileData.profile.bar_enrollment
      : profileData.bar_enrollment) || ""
  );
  const [law_firm_name, setlaw_firm_name] = useState(
    (haveProfile
      ? profileData.profile.law_firm_name
      : profileData.law_firm_name) || ""
  );
  const [state_code, setstate_code] = useState(
    haveProfile ? profileData.profile.state_code || "" : ""
  );
  const canEditAdditionalEmails = Boolean(partyType && caseId);
  const originalAdditionalEmails = useRef(getAdditionalEmails(profileData));
  const [additionalEmails, setAdditionalEmails] = useState(
    originalAdditionalEmails.current
  );
  const [newAdditionalEmail, setNewAdditionalEmail] = useState("");

  const selectedCountry = allCountries.find((c) => c.id === country);
  const countryCode = selectedCountry ? selectedCountry.code : "";
  const { states, cities } = useLocations(countryCode, state_code);

  React.useEffect(() => {
    if (!state_code && region && states.length > 0) {
      const match = states.find(s => s.name.toLowerCase() === region.toLowerCase());
      if (match) {
        setstate_code(match.iso2);
      }
    }
  }, [states, region, state_code]);

  React.useEffect(() => {
    if (!country) {
      setCountry("-");
    }
  }, []);

  const onNameChange = (e) => {
    clearError("name");
    setName(e.target.value);
  };
  const onPhoneChange = (e) => {
    clearError("phone");
    setPhone(e.target.value);
  };
  const onEmailChange = (e) => {
    clearError("email");
    setEmail(e.target.value);
  };
  // Returns the list with `value` appended, or null after flagging why it
  // can't be. A blank value leaves the list as it is.
  const withAdditionalEmail = (list, value) => {
    const candidate = (value || "").trim().toLowerCase();
    if (!candidate) return list;
    if (!EMAIL_PATTERN.test(candidate)) {
      setErrors({ additionalEmails: "Please enter valid email address." });
      return null;
    }
    const primary = (email.trim() || originalEmail.current || "").toLowerCase();
    if (candidate === primary) {
      setErrors({ additionalEmails: "This is already the primary email." });
      return null;
    }
    if (list.some((item) => item.toLowerCase() === candidate)) {
      setErrors({ additionalEmails: "This email is already added." });
      return null;
    }
    return [...list, candidate];
  };
  // Enter in the box creates a chip; the chip's x (or Backspace on an empty
  // box) removes one
  const onAdditionalEmailsChange = (e, value, reason) => {
    if (reason === "create-option") {
      const next = withAdditionalEmail(
        additionalEmails,
        value[value.length - 1]
      );
      if (!next) return;
      setAdditionalEmails(next);
      setNewAdditionalEmail("");
      return;
    }
    clearError("additionalEmails");
    setAdditionalEmails(value);
  };
  const onAdditionalEmailInputChange = (e, value, reason) => {
    // Autocomplete resets the text after every Enter; keep a rejected
    // address in the box so it can be corrected
    if (reason === "reset") return;
    clearError("additionalEmails");
    setNewAdditionalEmail(value);
  };
  const onAddressChange = (e) => {
    setAddress(e.target.value);
  };
  const onCityChange = (e) => {
    setcity(e.target.value);
  };
  const onRegionChange = (e) => {
    setregion(e.target.value);
  };
  const onPostalCodeChange = (e) => {
    setpostal_code(e.target.value);
  };
  const onGstNumberChange = (e) => {
    setgst_number(e.target.value);
  };
  const onPanNumberChange = (e) => {
    setpan_number(e.target.value);
  };
  const onBarEnrollmentChange = (e) => {
    setbar_enrollment(e.target.value);
  };
  const onLawFirmNameChange = (e) => {
    setlaw_firm_name(e.target.value);
  };

  const [openSnackBar1, setOpenSnackBar1] = useState(false);
  const handleCloseSnackBar1 = () => {
    setOpenSnackBar1(false);
  };
  const [openSnackBar2, setOpenSnackBar2] = useState(false);
  const handleCloseSnackBar2 = () => {
    setOpenSnackBar2(false);
    if (refresh) refresh();
  };
  const [saving, setSaving] = useState(false);

  async function updateProfile(profileData) {
    let {
      id,
      phone_number,
      address,
      city,
      region,
      state_code,
      postal_code,
      country,
      user,
      gst_number,
      pan_number,
      bar_enrollment,
      law_firm_name,
      additional_emails,
    } = profileData;
    return await instance({
      method: "patch",
      url: `/api/profile/${id}/?host=${getRealhost()}`,
      data: {
        phone_number: phone_number,
        address: address,
        city: city,
        region: region,
        state_code: state_code,
        postal_code: postal_code,
        gst_number: gst_number,
        pan_number: pan_number,
        ...(bar_enrollment !== undefined && { bar_enrollment: bar_enrollment }),
        ...(law_firm_name !== undefined && { law_firm_name: law_firm_name }),
        country: country,
        user,
        dispute_id: caseId,
        // additional_emails replaces the whole list for this dispute + party
        // type (anything left out is deleted), so it is only sent on a change
        ...(additional_emails
          ? {
            is_additional_email_updated: true,
            dispute: caseId,
            party_type: partyType,
            additional_emails,
          }
          : { is_additional_email_updated: false }),
      },
    });
  }

  const onSubmit = () => {
    const profileData = {
      id: id,
      phone_number: phone && phone.trim() != "" ? phone : null,
      address: address,
      city: city,
      region: region,
      state_code: state_code,
      postal_code: postal_code,
      gst_number: gst_number,
      pan_number: pan_number,
      ...(isCounsel && {
        bar_enrollment:
          bar_enrollment && bar_enrollment.trim() ? bar_enrollment.trim() : null,
      }),
      ...(isCounsel && {
        law_firm_name:
          law_firm_name && law_firm_name.trim() ? law_firm_name.trim() : null,
      }),
      country: country && country != "-" ? country : null,
      user: {
        first_name: name,
        last_name: "",
        email: email.trim() ? email : originalEmail.current,
      },
    };

    setErrors({});

    if (!name || name.trim() == "") {
      setErrors({ name: "Required" });
    } else {
      if (email.trim() && !EMAIL_PATTERN.test(email)) {
        setErrors({ email: "Please enter valid email address." });
      } else if (phone && phone.trim() && !isValidPhone(phone)) {
        setErrors({ phone: "Enter 10-digits phone number" });
      } else {
        if (canEditAdditionalEmails) {
          // An address typed but not yet turned into a chip with Enter still counts
          const finalEmails = withAdditionalEmail(
            additionalEmails,
            newAdditionalEmail
          );
          if (!finalEmails) return;
          if (finalEmails !== additionalEmails) {
            setAdditionalEmails(finalEmails);
            setNewAdditionalEmail("");
          }
          if (!sameEmailList(finalEmails, originalAdditionalEmails.current)) {
            profileData.additional_emails = finalEmails;
          }
        }
        setSaving(true);
        updateProfile(profileData)
          .then(() => {
            dispatch(
              updateDisputesNameForUserApi(user_id, getRealhost())
            )
            if (onSaved) {
              // Close right away; the parent's close handler refreshes the card
              onSaved();
            } else {
              setSaving(false);
              setOpenSnackBar2(true);
            }
          })
          .catch((error) => {
            setSaving(false);
            const data = error?.response?.data;
            console.log(data);
            setErrors({
              email: data?.user?.email ? String(data.user.email[0]) : "",
              phone: data?.phone_number ? String(data.phone_number[0]) : "",
              additionalEmails: data?.additional_emails
                ? String([].concat(...[].concat(data.additional_emails))[0])
                : "",
              form: data?.error ? String(data.error) : "",
            });
          });
        // let countspace = (phone.match(/ /g) || []).length;
        // if (countspace > 0) {
        //   if (countspace > 1) {
        //     setOpenSnackBar5(true);
        //   } else {
        //     if (/^\d+$/.test(phone.split(" ")[1])) {
        //       dispatch(updateProfile(profileData)).then((res) => {
        //       });
        //     } else {
        //       setOpenSnackBar5(true);
        //     }
        //   }
        // } else {
        //   if (/^\d+$/.test(phone)) {
        //     dispatch(updateProfile(profileData)).then((res) => {
        //     });
        //   } else {
        //     setOpenSnackBar5(true);
        //   }
        // }
      }
    }
  };

  return (
    <>
      <Grid container justify="center" spacing={2}>
        <Grid item md={5} sm={10} xs={12}>
          <TextField
            required
            id="name"
            name="name"
            label="Name"
            variant="outlined"
            fullWidth={true}
            value={name}
            error={!!errors.name}
            helperText={errors.name}
            onChange={onNameChange}
          />
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <TextField
            // required
            id="phone"
            name="phone"
            label="Phone Number"
            type="number"
            variant="outlined"
            fullWidth={true}
            value={phone}
            error={!!errors.phone}
            helperText={errors.phone}
            onKeyDown={blockInvalidChar}
            onChange={onPhoneChange}
          />
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <TextField
            required={isEmailRequired}
            id="email"
            name="email"
            label="Email ID"
            variant="outlined"
            fullWidth={true}
            value={email}
            error={!!errors.email}
            helperText={errors.email}
            onChange={onEmailChange}
          />
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <TextField
            id="Apartment and Street"
            name="Apartment and Street"
            label="Apartment and Street"
            variant="outlined"
            fullWidth={true}
            value={address}
            onChange={onAddressChange}
          />
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-country-select-label">Country</InputLabel>
            <Select
              label="Country"
              labelId="demo-country-select-label"
              id="demo-country-select"
              value={country}
              onChange={(e) => {
                setCountry(e.target.value);
                setstate_code("");
                setregion("");
                setcity("");
              }}
            >
              <MenuItem value={"-"}>---</MenuItem>
              {allCountries.map((country) => {
                return (
                  <MenuItem key={country.id} value={country.id}>
                    {country.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-state-select-label">State</InputLabel>
            <Select
              label="State"
              labelId="demo-state-select-label"
              id="demo-state-select"
              value={state_code}
              onChange={(e) => {
                const code = e.target.value;
                const stateObj = (states || []).find(s => s.iso2 === code);
                setstate_code(code);
                setregion(stateObj ? stateObj.name : "");
                setcity("");
              }}
            >
              <MenuItem value={""}>---</MenuItem>
              {state_code && !(states || []).some(s => s.iso2 === state_code) && (
                <MenuItem value={state_code}>{region || state_code}</MenuItem>
              )}
              {(states || []).map((s) => (
                <MenuItem key={s.id} value={s.iso2}>
                  {s.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="demo-city-select-label">City</InputLabel>
            <Select
              label="City"
              labelId="demo-city-select-label"
              id="demo-city-select"
              value={city}
              onChange={(e) => {
                setcity(e.target.value);
              }}
            >
              <MenuItem value={""}>---</MenuItem>
              {city && !(cities || []).some(c => c.name.toLowerCase() === city.toLowerCase()) && (
                <MenuItem value={city}>{city}</MenuItem>
              )}
              {(cities || []).map((c) => (
                <MenuItem key={c.id} value={c.name}>
                  {c.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={5} sm={10} xs={12}>
          <TextField
            id="postal_code"
            name="postal_code"
            label="Postal Code"
            variant="outlined"
            fullWidth={true}
            value={postal_code}
            onChange={onPostalCodeChange}
          />
        </Grid>
        {isSebi && <Grid item md={5} sm={10} xs={12}>
          <TextField
            id="gst_number"
            name="gst_number"
            label="Gst Number"
            variant="outlined"
            fullWidth={true}
            value={gst_number}
            onChange={onGstNumberChange}
          />
        </Grid>}
        {isSebi && (profileData?.profile?.profile_type == "arbitrator_rv" || profileData?.profile?.profile_type == "mediator") &&
          <Grid item md={5} sm={10} xs={12}>
            <TextField
              id="pan_number"
              name="pan_number"
              label="Pan Number"
              variant="outlined"
              fullWidth={true}
              value={pan_number}
              onChange={onPanNumberChange}
            />
          </Grid>
        }
        {isCounsel && (
          <>
            <Grid item md={5} sm={10} xs={12}>
              <TextField
                id="bar_enrollment"
                name="bar_enrollment"
                label="Bar Enrollment No."
                variant="outlined"
                fullWidth={true}
                value={bar_enrollment}
                onChange={onBarEnrollmentChange}
              />
            </Grid>
            <Grid item md={5} sm={10} xs={12}>
              <TextField
                id="law_firm_name"
                name="law_firm_name"
                label="Law Firm Name"
                variant="outlined"
                fullWidth={true}
                value={law_firm_name}
                onChange={onLawFirmNameChange}
              />
            </Grid>
          </>
        )}
        {canEditAdditionalEmails && (
          <Grid item md={10} sm={10} xs={12}>
            <Autocomplete
              multiple
              freeSolo
              options={[]}
              value={additionalEmails}
              inputValue={newAdditionalEmail}
              onChange={onAdditionalEmailsChange}
              onInputChange={onAdditionalEmailInputChange}
              renderTags={(value, getTagProps) =>
                value.map((item, index) => (
                  <Chip
                    {...getTagProps({ index })}
                    key={item}
                    label={item}
                    size="small"
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="additional_emails"
                  label="Additional Emails"
                  variant="outlined"
                  fullWidth={true}
                  error={!!errors.additionalEmails}
                  helperText={
                    errors.additionalEmails || "Type an email and press Enter"
                  }
                />
              )}
            />
          </Grid>
        )}
      </Grid>
      <FormError message={errors.form} />
      <Box height="1.5rem"></Box>
      <Button
        variant="contained"
        color='primary'
        // style={{ background: "#2F80ED", color: TEXT.onDark }}
        size="large"
        className={classes.bigbtn}
        onClick={onSubmit}
        disabled={saving}
        startIcon={saving ? <CircularProgress size={18} color="inherit" /> : null}
      >
        {saving ? "Saving..." : "Save"}
      </Button>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar1}
        onClose={handleCloseSnackBar1}
        message="Problem in creating guest profile."
      // key={vertical + horizontal}
      >
        <Alert onClose={handleCloseSnackBar1} severity="error">
          Problem in creating guest profile.
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar2}
        onClose={handleCloseSnackBar2}
        message="Guest profile is created."
      // key={vertical + horizontal}
      >
        <Alert onClose={handleCloseSnackBar2} severity="success">
          Profile is edited.
        </Alert>
      </Snackbar>
    </>
  );
}
